export const GB_stNull = 0;
export const GB_stDesignEffectComment = 1;
export const GB_stEstFreqComment = 2;
export const GB_stAddIndNote = 3;
export const GB_stRemoveIndNote = 4;
export const GB_stMoveIndUpNote = 5;
export const GB_stMoveIndDownNote = 6;
export const GB_stApply = 7;
export const GB_stMngCustomIndicators = 8;
export const GB_stIndicator = 9;
export const GB_stGroup = 10;
export const GB_stAssignIndGroup = 11;
export const GB_stSelect = 12;
export const GB_stParameter = 13;
export const GB_stValue = 14;
export const GB_stSelectTargPop = 15;
export const GB_stStartAgeXX = 16;
export const GB_stEndAgeYY = 17;
export const GB_stRefPeriodZZ = 18;
export const GB_stGender = 19;
export const GB_stIndInstructions = 20;
export const GB_stAllIndFillOut = 21;
export const GB_stIndCompleted = 22;
export const GB_stHowSpecTargPop = 23;
export const GB_stChooseDefTargPop = 24;
export const GB_stEnterCustomTargPop = 25;
export const GB_stSpecParamsTargPop = 26;
export const GB_stParameters = 27;
export const GB_stParamHelpText = 28;
export const GB_stEditIndInstruct = 29;
export const GB_stGroups = 30;
export const GB_stTargPop = 31;
export const GB_stEstFreq = 32;
export const GB_stDesPrecision = 33;
export const GB_stPercPoints = 34;
export const GB_stDesignEffect = 35;
export const GB_stDesNumHHs = 36;
export const GB_stEstBaseFreq = 37;
export const GB_stEstEndFreq = 38;
export const GB_stDesHHsPerSurvey = 39;
export const GB_stArm1 = 40;
export const GB_stArm2 = 41;
export const GB_stEnterParamsFor = 42;
export const GB_stPrecisions = 43;
export const GB_stNumHHs = 44;
export const GB_stDifference = 45;
export const GB_stDownloadTable = 46;
export const GB_stReqNumTargIndiv = 47;
export const GB_stReqNumHHs = 48;
export const GB_stRelatedPrecision = 49;
export const GB_stReqNumTargPopPerSurvey = 50;
export const GB_stReqNumHHsPerSurvey = 51;
export const GB_stReqNumIndivPerArm = 52;
export const GB_stDetectDiffArms = 53;
export const GB_stDisplayResultsFor = 54;
export const GB_stYourIndicators = 55;
export const GB_stClear = 56;
export const GB_stSelectIndInstruct = 57;
export const GB_stWelcomeToAppTitle = 58;
export const GB_stToolDescription = 59;
export const GB_stChooseOption = 60;
export const GB_stPrecBasedOption = 61;
export const GB_stPrecBasedOptionDescription = 62;
export const GB_stPowerBasedOption = 63;
export const GB_stPowerBasedOptionDescription = 64;
export const GB_stWomenSlashMen = 65;
export const GB_stNA = 66;
export const GB_stXX = 67;
export const GB_stYY = 68;
export const GB_stZZ = 69;
export const GB_stBack = 70;
export const GB_stNext = 71;
export const GB_stSampleSizeCalculator = 72;
export const GB_stAbout = 73;
export const GB_stWelcomePageImage = 74;
export const GB_stChooseMode = 75;
export const GB_stSelectIndicators = 76;
export const GB_stAssignTargPops = 77;
export const GB_stResults = 78;
export const GB_stPrecision = 79;
export const GB_stPowerChange = 80;
export const GB_stSettings = 81;
export const GB_stLanguage = 82;
export const GB_stInformation = 83;
export const GB_stDemandFamPlanSat = 84;
export const GB_stNeonatalTetanusProtectPregW = 85;
export const GB_stCPR = 86;
export const GB_stUsingContracept = 87;
export const GB_stFamPlanDisc = 88;
export const GB_stANC = 89;
export const GB_stContentANC = 90;
export const GB_stAccompANC_Visit = 91;
export const GB_stPartnerANC_Consult = 92;
export const GB_stHIV_TestANC = 93;
export const GB_stHIV_CounsANC = 94;
export const GB_stITN_CovPregW = 95;
export const GB_stIPTp = 96;
export const GB_stIronAcidFolicSuppPregW = 97;
export const GB_stSBA = 98;
export const GB_stInstitutionalDeliv = 99;
export const GB_stPartnerLabourDelivery = 100;
export const GB_stC_Section = 101;
export const GB_stPostnatalVisitMother = 102;
export const GB_stPostnatalVisitNewborn = 103;
export const GB_stThermalCordCare = 104;
export const GB_stSkinToSkinCare = 105;
export const GB_stBCG = 106;
export const GB_stMeaslesImmun = 107;
export const GB_stPentaDPT3Immun = 108;
export const GB_stPneumoImmun = 109;
export const GB_stRotavirusImmun = 110;
export const GB_stITN_ChildrenU5 = 111;
export const GB_stEpisodeFever = 112;
export const GB_stEpisodeDiar = 113;
export const GB_stEpisodeSuspectPneum = 114;
export const GB_stCareSeekFever = 115;
export const GB_stMalariaFirstLineTreatment = 116;
export const GB_stCareSeekDiar = 117;
export const GB_stCareSeekSuspectPneum = 118;
export const GB_stORS_TreatDiar = 119;
export const GB_stZincTreatDiar = 120;
export const GB_stORS_ZincTreatDiar = 121;
export const GB_stAntimalarialTreat = 122;
export const GB_stChildEverBreastfed = 123;
export const GB_stExclBF_LT6Mo = 124;
export const GB_stEarlyInitBF = 125;
export const GB_stContBF_At1Yr = 126;
export const GB_stContBF_At2Yr = 127;
export const GB_stApprFeedPract = 128;
export const GB_stVitASupp = 129;
export const GB_stIntroSolidSoftFoods = 130;
export const GB_stMinDietDiversity = 131;
export const GB_stMinMealFrequency = 132;
export const GB_stMinAcceptableDiet = 133;
export const GB_stUnderweightPrevChildren = 134;
export const GB_stStuntingPrevChildren = 135;
export const GB_stWastingPrevChildren = 136;
export const GB_stOverweightPrevChildren = 137;
export const GB_stAvailITNs = 138;
export const GB_stITN_HH_Cov = 139;
export const GB_stIRS = 140;
export const GB_stImpDrinkWaterSrc = 141;
export const GB_stImpDrinkWaterSrcHH_Cov = 142;
export const GB_stImpSanitFacil = 143;
export const GB_stImpSaniFacil_HH_Cov = 144;
export const GB_stSafeDisposalChildStools = 145;
export const GB_stWealthIdxQuintile = 146;
export const GB_stBirthRegistration = 147;
export const GB_stEarlyFirstMarriageUnion = 148;
export const GB_stYoungW_MarriedUnion = 149;
export const GB_stEarlyChildbearing = 150;
export const GB_stPrevFGM_W = 151;
export const GB_stPrevFGM_Girls = 152;
export const GB_stMultiSexPartners = 153;
export const GB_stCondomUseLastSexMultiSexPartners = 154;
export const GB_stSexNonRegPartners = 155;
export const GB_stCondomUseNonRegPartners = 156;
export const GB_stNeverMarriedChildrenNotSexActive = 157;
export const GB_stSexBefore15Yrs = 158;
export const GB_stSexActiveChildrenPastYear = 159;
export const GB_stHIV_TestLast12MoResultsKnown = 160;
export const GB_stEmploymentLast7Days = 161;
export const GB_stEmploymentLast12Mo = 162;
export const GB_stCashEarnings = 163;
export const GB_stBankAccounts = 164;
export const GB_stOwnershipMobilePhones = 165;
export const GB_stMobilePhoneFinancTransactions = 166;
export const GB_stCtrlOverOwnIncome = 167;
export const GB_stCtrlOverPartnerEarnings = 168;
export const GB_stDecisMakingOwnHlthCare = 169;
export const GB_stLeavHouseW = 170;
export const GB_stWomenInUnionOrSexActiveTargPopParam = 171;
export const GB_stWomenWithLiveBirthTargPopParam = 172;
export const GB_stInfantsSurveyedTargPopParam = 173;
export const GB_stChildrenU5SleptHouseTargPopParam = 174;
export const GB_stChildrenU5TargPopParam = 175;
export const GB_stChildrenU5Fever2WksTargPopParam = 176;
export const GB_stChildrenU5Fever2WksDrugsTargPopParam = 177;
export const GB_stChildrenU5Diar2WksTargPopParam = 178;
export const GB_stChildrenU5Pneum2WksTargPopParam = 179;
export const GB_stHHInterviewedTargPopParam = 180;
export const GB_stHHMembersSleptHouseTargPopParam = 181;
export const GB_stMembersInterviewedHHTargPopParam = 182;
export const GB_stCaretakersDispChildrenStoolsTargPopParam = 183;
export const GB_stWomenTargPopParam = 184;
export const GB_stDaughters0t14TargPopParam = 185;
export const GB_stPeopleTargPopParam = 186;
export const GB_stPeopleMultiSexPartnersTargPopParam = 187;
export const GB_stPeopleHadSexTargPopParam = 188;
export const GB_stPeopleHadSexNonMarCohabPartnerTargPopParam = 189;
export const GB_stPeopleNeverMarriedTargPopParam = 190;
export const GB_stPeopleTestedHIVTargPopParam = 191;
export const GB_stPeopleMarCohabPartnerUnionTargPopParam = 192;
export const GB_stInfants12t15MoSurveyedTargPopParam = 193;
export const GB_stInfants20t23MoSurveyedTargPopParam = 194;
export const GB_stInfants6t23MoSurveyedTargPopParam = 195;
export const GB_stInfants6t59MoSurveyedTargPopParam = 196;
export const GB_stInfants6t8MoSurveyedTargPopParam = 197;
export const GB_stWomen20t24TargPopParam = 198;
export const GB_stWomen15t49TargPopParam = 199;
export const GB_stPeople15t24TargPopParam = 200;
export const GB_stPeople15t49TargPopParam = 201;
export const GB_stFamPlanGroup = 202;
export const GB_stAntenatalCareGroup = 203;
export const GB_stDelivChildbirthGroup = 204;
export const GB_stPostnatalCareGroup = 205;
export const GB_stChildHlthPrevGroup = 206;
export const GB_stChildHlthCurGroup = 207;
export const GB_stNutritionGroup = 208;
export const GB_stNutritionImpactGroup = 209;
export const GB_stVectorCtrlGroup = 210;
export const GB_stWaterSanitGroup = 211;
export const GB_stPovertyGroup = 212;
export const GB_stChildProtectGroup = 213;
export const GB_stSexBehavGroup = 214;
export const GB_stSexHlthGroup = 215;
export const GB_stGenderEmpowerGroup = 216;
export const GB_stCustomIndGroup = 217;
export const GB_stWomenInUnionOrSexActiveTargPop = 218;
export const GB_stWomenWithLiveBirthTargPop = 219;
export const GB_stInfantsSurveyedTargPop = 220;
export const GB_stChildrenU5SleptHouseTargPop = 221;
export const GB_stChildrenU5TargPop = 222;
export const GB_stChildrenU5Fever2WksTargPop = 223;
export const GB_stChildrenU5Fever2WksDrugsTargPop = 224;
export const GB_stChildrenU5Diar2WksTargPop = 225;
export const GB_stChildrenU5Pneum2WksTargPop = 226;
export const GB_stHHInterviewedTargPop = 227;
export const GB_stHHMembersSleptHouseTargPop = 228;
export const GB_stMembersInterviewedHHTargPop = 229;
export const GB_stCaretakersDispChildrenStoolsTargPop = 230;
export const GB_stWomenTargPop = 231;
export const GB_stDaughters0t14TargPop = 232;
export const GB_stPeopleTargPop = 233;
export const GB_stPeopleMultiSexPartnersTargPop = 234;
export const GB_stPeopleHadSexTargPop = 235;
export const GB_stPeopleHadSexNonMarCohabPartnerTargPop = 236;
export const GB_stPeopleNeverMarriedTargPop = 237;
export const GB_stPeopleTestedHIVTargPop = 238;
export const GB_stPeopleMarCohabPartnerUnionTargPop = 239;
export const GB_stInfants12t15MoSurveyedTargPop = 240;
export const GB_stInfants20t23MoSurveyedTargPop = 241;
export const GB_stInfants6t23MoSurveyedTargPop = 242;
export const GB_stInfants6t59MoSurveyedTargPop = 243;
export const GB_stInfants6t8MoSurveyedTargPop = 244;
export const GB_stWomen20t24TargPop = 245;
export const GB_stWomen15t49TargPop = 246;
export const GB_stPeople15t24TargPop = 247;
export const GB_stPeople15t49TargPop = 248;
export const GB_stCustomTargPop = 249;
export const GB_stCloseBtn = 250;
export const GB_stOkBtn = 251;
export const GB_stCancelBtn = 252;
export const GB_stYesBtn = 253;
export const GB_stNoBtn = 254;
export const GB_stAddBtn = 255;
export const GB_stDeleteBtn = 256;
export const GB_stNoRowsToShow = 257;
export const GB_stCustomIndicator = 258;
export const GB_stNumIntervHHs = 259;
export const GB_stHHResponseRate = 260;
export const GB_stEnterFollowingParams = 261;
export const GB_stFrench = 262;
export const GB_stEnglish = 263;
export const GB_stAboutRSSC = 264;
export const GB_stAboutRADARText = 265;
export const GB_stCredits = 266;
export const GB_stContactUs = 267;
export const GB_stContact = 268;
export const GB_stQuestComments = 269;
